import TextInput from '@/components/refinedev/TextInput';
import TextareaInput from '@/components/refinedev/TextareaInput';
import Section from '@/components/surface/Section';
import {useCategoryList} from 'pages/_utils';
import {ThousandSeparatorTextInput} from '@/components/refinedev/MaskTextInput';
import DatepickerInput from '@/components/refinedev/DatepickerInput';
import formatter from '@/lib/formatter';
import {Tabs, TabsContent, TabsList, TabsTrigger} from '@/shadcn_components/ui/tabs';
import RichTextInput from '@/components/refinedev/RichTextInput';
import { FileInput } from '@/components/refinedev/FileInput';

const ProjectContractForm = () => {
  return (
    <Tabs defaultValue="general_info">
      <ProjectContractForm_TabsList />
      <ProjectContractForm_TabsContents />
    </Tabs>
  );
};

export const ProjectContractForm_TabsList = () => (
  <TabsList className="flex gap-x-4">
    <TabsTrigger value="general_info">Thông tin chung</TabsTrigger>
    <TabsTrigger value="contents">Nội dung</TabsTrigger>
    <TabsTrigger value="documents">Tài liệu đính kèm</TabsTrigger>
  </TabsList>
);

export const ProjectContractForm_TabsContents = () => (
  <>
    <TabsContent value="general_info" forceMount>
      <Section
        title="Thông tin hợp đồng"
        bodyProps={{className: 'flex flex-col gap-2'}}
        className="mx-auto">
        <ProjectContractForm_GeneralInfo />
      </Section>
    </TabsContent>

    <TabsContent value="contents" forceMount>
      <Section
        className="mx-auto"
        title="Nội dung hợp đồng"
        subtitle="Nội dung chi tiết của hợp đồng">
        <RichTextInput source="content" label="Nội dung" />
      </Section>
    </TabsContent>

    <TabsContent value="documents" forceMount>
      <Section title="Tài liệu đính kèm" subtitle="Tài liệu hợp đồng" className="mx-auto">
        <FileInput source="attachments" label="File đính kèm" multiple />
      </Section>
    </TabsContent>
  </>
);

export const ProjectContractForm_GeneralInfo = () => {
  return (
    <>
      <TextInput source="name" label="Tiêu đề" />
      <ThousandSeparatorTextInput source="value" label="Giá trị hợp đồng" />
      <div className="grid grid-cols-2 gap-4">
        <DatepickerInput source="start_date" label="Ngày bắt đầu" />
        <DatepickerInput source="end_date" label="Ngày kết thúc" />
      </div>
      <TextareaInput source="description" label="Tóm tắt" />
    </>
  );
};

export const transformBeforeSave = inputData => {
  const data = {
    ...inputData,
    start_date: inputData.start_date ? formatter.formatDateSQL(inputData.start_date) : undefined,
    end_date: inputData.end_date ? formatter.formatDateSQL(inputData.end_date) : undefined,
  };
  // many-to-many normalize
  // data = convertManyToManyField(data, 'categories');
  // data = convertManyToManyField(data, 'image_album');
  // data.author = undefined;
  return data;
};

ProjectContractForm.transformBeforeSave = transformBeforeSave;

export default ProjectContractForm;
